











































































































































































































































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import { SelectWings, FastDateDetailWings, DatePickerWings, NumberWings, InputWings } from "wings-ui-components";
import { CustomDetailFilterParams } from "@/store/custom/statistic/types";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { notifyError, notifyWarning } from "@/utils/notify-helper";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { MessageTypeItem } from "@/store/settings/message_types/types";
import { MsgTransports } from '@/store/types';
import { getTranslatedParams } from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings, FastDateDetailWings,
    DatePickerWings, NumberWings,
    InputWings
  },
  filters: {dateFilter}
})
export default class CustomDetailFilter extends BaseFilter<CustomDetailFilterParams> {

  @PropSync('showAdditional') is_show_additional!: boolean;
  @PropSync("filterClone") propFilterClone!: CustomDetailFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Action("getOriginators") actionGetOriginators: any;
  @Action("getCustomStatisticDetail") actionGetItems: any;
  @Action("exportCustomStatisticDetail") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getMessageCategories") actionMessageCategories: any;
  @Action("actionLog") actionLog: any;

  @Getter("messageTypes") messageTypesList?: MessageTypeItem[];
  @Getter("customMessagesStatusList") statusList!: string[];
  @Getter("messageCategories") messageCategoriesList: any;

  params: object = {transport: MsgTransports.CUSTOM};
  partnersList: any = []
  originatorsList: any = []
  accountsList: any = []
  partnerUsersList: any = []
  partnerUsersEmailList: any = []
  serviceProvidersList:  any = []

  filterKeys: object = {
    "originator" : "addresser",
    "recipient" : "receiver",
    "broker_account_login" : "account",
    "transport_message_id" : "smpp_message_id",
    "partner_user_login": "partner_login"
  }

  defaultFilter(): CustomDetailFilterParams {
    return new CustomDetailFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async getPartnerUsersEmailList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersEmailList = (filter?.page_number > 1) ? this.partnerUsersEmailList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created(): Promise<void> {
    try {
      await this.actionGetMessageTypes();
      await this.actionMessageCategories(this.params);
      this.scroll();
    } catch (error) {
      notifyError(error);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.partner_user_login) this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.partner_user_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp?.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  doActionExport(filter: CustomDetailFilterParams): Promise<any> {
    return this.actionExport(filter);
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChange(newVal: CustomDetailFilterParams): void {
    this.propFilterClone = newVal;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilterChange(val: boolean): void {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

}
